import { State } from '@progress/kendo-data-query';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { FC, useMemo } from 'react';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';

export interface DropDownOption {
  key: number;
  label: string;
}
interface GridToolbarProps {
  clearFilter: () => void;
  showFilter: boolean;
  state: State;
  onVarianceDropDownChange?: (event: DropDownListChangeEvent) => void;
  varianceDropDownValue?: DropDownOption;
}

export const varianceOptions: DropDownOption[] = [
  { key: 1, label: 'Show All' },
  { key: 2, label: 'Show Variances' },
];

const VarianceDetailsToolBar: FC<GridToolbarProps> = ({
  clearFilter,
  showFilter,
  state,
  onVarianceDropDownChange,
  varianceDropDownValue,
}) => {
  const isClearFiltersDisabled = useMemo(() => {
    if (showFilter) {
      return varianceDropDownValue?.key === 1 && !state.filter?.filters.length;
    }
    return !state.filter?.filters.length;
  }, [showFilter, state.filter?.filters.length, varianceDropDownValue?.key]);
  return (
    <div className="flex justify-between items-center px-2 w-full">
      <ClearFilterButton disabled={isClearFiltersDisabled} onClick={clearFilter} />
      {showFilter && (
        <DropDownList
          id="view-drop-down-list-variance"
          style={{ width: '200px' }}
          data={varianceOptions}
          value={varianceDropDownValue}
          textField="label"
          dataItemKey="key"
          onChange={onVarianceDropDownChange}
        />
      )}
    </div>
  );
};
export default VarianceDetailsToolBar;
